import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useMemo } from 'react';
import WrapPage from '@/components/base/Layout/wrap';
import Table from '@/components/base/Table';
import ListHeader from '@/components/base/Layout/ListHeader';
import { makeShardColumns } from '@/constants/Shard';
import getShardService from '@/api/shard';
import { globalShardFirst } from '@/utils/shard';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
var shardService = getShardService();
var Shards = function() {
    var ref = useState([]), shards = ref[0], setShards = ref[1];
    var ref1 = useState(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = useState({
        pageSize: 10,
        total: shards.length,
        onPageChange: function(item) {
            console.log(item);
        }
    }), pageOpt = ref2[0], setPageOpt = ref2[1];
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh) {
            getShards();
        }
    }, [
        refresh
    ]);
    var getShards = useCallback(function() {
        setLoading(true);
        shardService.getShardList().then(function(response) {
            var data = globalShardFirst(response.Result);
            setShards(data);
        }).finally(function() {
            return setLoading(false);
        });
        return;
    }, []);
    useEffect(function() {
        return getShards();
    }, []); // global
    var total = useMemo(function() {
        return !!shards.length ? shards.length - 1 : 0;
    }, [
        shards
    ]);
    return(/*#__PURE__*/ _jsx(ListHeader, {
        title: "Shards",
        desc: "Shards",
        total: total,
        children: /*#__PURE__*/ _jsx(Table, {
            className: "single-line",
            columns: makeShardColumns(),
            data: shards,
            loading: loading,
            tableLayout: "fixed",
            rowKey: "ShardIndex",
            pageOpt: pageOpt
        })
    }));
};
export default WrapPage(observer(Shards));
